export const getCarrierView = async (driverCode, carrierViewQueryString) => {

    if (driverCode === undefined) {
        console.error('Oh noes getCarrierView driverCode is undefined!')
    }

    let firstTry = await APICall(driverCode, 10000)
    // console.log('getCarrierView first', firstTry)
    if (typeof firstTry === 'object' && firstTry !== null) {
        return firstTry
    } else {
        let secondTry = await APICall(driverCode, 20000)
        if (typeof secondTry === 'object' && secondTry !== null) {
            return secondTry
        } else {
            let thridTry = await APICall(driverCode, 45000)
            if (typeof thridTry === 'object' && thridTry !== null) {
                return thridTry
            } else {
                console.warn("getCarrierView saw an api call fail 3x")
                return 'failed'
            }
        }
    }

    async function APICall(driverCode, timeOutValue) {

        return new Promise(function (resolve, reject) {

            let controller = new AbortController();

            let url =
                "https://api.shippersedge.com/schedule/carrierView/"

            if (carrierViewQueryString && carrierViewQueryString !== "") {
                // console.log('getDataNew carrierViewQueryString', carrierViewQueryString)
                url = url + carrierViewQueryString
            }

            let myHeaders = new Headers();
            myHeaders.append("x-api-key", "vdhy8wwjUJrwhxFpfuECTiAW");
            myHeaders.append("Content-Type", "application/json");
            var raw = JSON.stringify({ "driverCode": driverCode });
            var requestOptions = {
                method: "POST",
                body: raw,
                headers: myHeaders,
                redirect: "follow",
            };

            let request = new Request(url, requestOptions);

            if (timeOutValue) {
                setTimeout(() => controller.abort(), timeOutValue);
            }


            fetch(request)
                .then((response) => {
                    // console.log(
                    //     "debug getCarrierView.js response",
                    //     response
                    // );
                    if (!response.ok) {
                        console.error(
                            "getCarrierView.js error",
                            response.statusText,
                            response
                        );
                        throw Error(response.statusText);
                    }
                    return response.json();
                })
                .then((response) => {
                    // console.log('getCarrierView', response)
                    resolve(response);
                })
                .catch((err) => {
                    console.error("getCarrierView API Request failed", err);
                    resolve(err);
                });
        });
    }
};

export default getCarrierView